import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
}

const Overlay = styled.dialog`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  margin: 0;
  border: none;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme: { spacing } }) => spacing(4)};
`;

const Card = styled.div`
  ${({ theme: { colors, spacing, media } }) => `
    position: relative;
    width: 100%;
    max-width: 32rem;
    max-height: 90vh;
    background-color: ${colors.veryGray};
    border-radius: ${spacing(3)};
    display: flex;
    flex-direction: column;
    overflow: hidden;

    ${media.medium(
      () => `
        max-height: 85vh;
      `,
    )}
  `}
`;

export const Modal = ({ open, onOpenChange: _onOpenChange, children }: ModalProps) => {
  useEffect(() => {
    if (!open) {
      return;
    }
    const { body } = document;
    const previousOverflow = body.style.overflow;
    body.style.overflow = 'hidden';
    return () => {
      body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return createPortal(
    <Overlay open={true} aria-modal="true">
      <Card>{children}</Card>
    </Overlay>,
    document.body,
  );
};
